<template>
    <div>
        <Card :padding="0">
            <!--标题-->
            <p slot="title" class="card-title">
                <Icon type="map"></Icon>
                {{chartsTitle}}
            </p>
            <!--查看更多-->
            <a href="#" slot="extra" v-show="isShowMore" @click.prevent="changeLimit">
                <Icon type="ios-loop-strong"></Icon>
                查看更多
            </a>
            <!--图表-->
            <div :style="{height: height}">
                <div style="width:100%;height:100%;" :id="chartsId" v-show="!isShow"></div>
                <div class="chart-error" v-show="isShow">
                    <div class="detail">
                        <span class="detail">暂无数据</span>
                    </div>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>
    export default {
        name: "double-hist-chars",
        props: {
            chartsTitle: String,//图表标题
            chartsId: String,//图表id
            height: String,//图表id
            histogramTooltip: String,//柱状图提示语
            // isSchool: Boolean,//展示的是否为学校
            // isIntervalDisplay: Boolean,//是否间隔显示数据
            isShowMore: Boolean,//是否展示查看更多
            isShowMoreData: String,//是否展示查看更多
            isClickCharts: Boolean,//是否可以点击柱状图
            colorArr: {
                type: Array,
                default:()=> ['#003366', '#006699', '#4cabce', '#e5323e']
            },
            fontColor: {
                type: String,
                default: '#757C8C'
            },
            fontSize: {
                type: String,
                default: '12px'
            },
            //是否显示DataZoom
            isShowDataZoom: {
                type: Boolean,
                default: false
            },
            //是否是否停止DataZoom的功能
            isDisableDataZoom: {
                type: Boolean,
                default: true
            },
            bottomHeight: {
                type: String,
                default: '60px'
            }
        },
        methods: {
            /**
             * 查看更多数据
             */
            changeLimit() {
                this.$emit('look-more-data', this.chartsId);
            },
            /**
             *渲染图表
             */
            initDataSource(data, xDataArr, seriesDataArr) {
                let _this = this;
                let dataSource = _this.$echarts.init(
                    document.getElementById(_this.chartsId)
                );
                const option = {
                        // tooltip: {
                        //     trigger: "axis",
                        //     axisPointer: {
                        //         // 坐标轴指示器，坐标轴触发有效
                        //         type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                        //     },
                        //     //自定义悬浮框内容
                        //     formatter: function (params) {
                        //         var color = _this.colorArr[0].color;//图例颜色
                        //         var htmlStr = '<div>';
                        //         htmlStr += params[0].name + '<br/>';//x轴的名称
                        //         //添加圆点
                        //         htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + color + ';"></span>';
                        //         //添加一个汉字，动态的自定义文本内容
                        //         htmlStr += tooltipHead + params[0].value + tooltipCompany;
                        //         htmlStr += '</div>';
                        //         return htmlStr;
                        //     }
                        // },
                        color: _this.colorArr,
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        legend: {
                            show: true,
                            data: ['Forest', 'Steppe', 'Desert', 'Wetland']
                        },
                        dataZoom: [
                            {
                                show: this.isShowDataZoom,
                                disabled: this.isDisableDataZoom,
                                realtime: true,
                                start: 0,
                                end: 100
                            },
                            {
                                type: 'inside',
                                disabled: this.isDisableDataZoom,
                                realtime: true,
                                start: 60,
                                end: 100

                            }
                        ],
                        xAxis: {
                            type: "category",
                            data: xDataArr,
                            axisTick: {show: false},
                            axisLabel: {
                                textStyle: {
                                    color: _this.fontColor, //颜色
                                    fontSize: _this.fontSize  //大小
                                },
                                interval: _this.isIntervalDisplay === true ? Math.round(xDataArr.length / 10) : 0,
                                rotate: _this.isSchool === true ? 20 : 40
                            }
                        },
                        yAxis: {
                            type: "value",
                            axisLabel: {
                                // formatter: '{value}' + tooltipCompany
                                formatter: '{value}'
                            },
                            textStyle: {
                                color: _this.fontColor, //颜色
                                fontSize: _this.fontSize  //大小
                            }
                        },
                        grid: {
                            // left: 75,
                            bottom: _this.bottomHeight
                        },
                        series: [
                            {
                                name: 'Forest',
                                data: [320, 332, 301, 334, 390],
                                type: 'bar',
                                itemStyle: {
                                    normal: {
                                        label: {
                                            show: true, //开启显示
                                            position:
                                                "top", //在上方显示
                                            textStyle:
                                                {
                                                    //数值样式
                                                    color: _this.fontColor,
                                                    fontSize: _this.fontSize
                                                }
                                            ,
                                            // formatter: function (params) {
                                            //     if (params.value > 1000) {
                                            //         let value = parseInt(params.value / 1000);
                                            //         return value + '千+';
                                            //     } else if (params.value > 10000) {
                                            //         let value = parseInt(params.value / 10000);
                                            //         return value + '万+';
                                            //     } else {
                                            //         return params.value + tooltipCompany;
                                            //     }
                                            // }
                                        }
                                        // , color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, _this.colorArr)
                                    }
                                },
                                barGap: 0,
                                barCategoryGap: "40%"
                            },
                            {
                                name: 'Steppe',
                                type: 'bar',
                                data: [220, 182, 191, 234, 290]
                            },
                            {
                                name: 'Desert',
                                type: 'bar',
                                data: [150, 232, 201, 154, 190]
                            },
                            {
                                name: 'Wetland',
                                type: 'bar',
                                data: [98, 77, 101, 99, 40]
                            }
                        ]
                    }
                ;
                dataSource.setOption(option);
                if (_this.isClickCharts) {
                    dataSource.on('click', function (params) {
                        _this.$emit('click-more-data', params, _this.chartsId, _this.productKey);
                    });
                }
                window.addEventListener("resize", function () {
                    dataSource.resize();
                });
            },
            /**
             * 根据isSchool字段来初始化bottomHeight 所有引用的地方兼容后删除
             */
            initBottomHeight() {
                this.bottomHeightLocal = this.bottomHeight;
                if (this.isSchool) {
                    this.bottomHeightLocal = '100px';
                }
            }
        }
    }
</script>

<style scoped>

</style>
